export default "__VITE_ASSET__21b90da4__"